export default "__VITE_ASSET__5bc52eb9__"